var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSd = function SvgSd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.945c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z",
    fill: "#07C166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.792 6.29c.19.021.31.214.247.394l-.928 2.638a.298.298 0 0 1-.534.06l-.198-.318-3.583 2.239-.368-.59a2.01 2.01 0 0 1 .64-2.77l1.877-1.174-.218-.348a.298.298 0 0 1 .287-.454l2.778.322Zm-3.756 6.116a2.706 2.706 0 0 0-.99 3.696l3.645-2.104a2.01 2.01 0 0 0 .736-2.747l-.348-.602-3.043 1.757Z",
    fill: "#fff"
  })));
};
export default SvgSd;